<div class="row justify-content-between align-items-center" mat-dialog-title>
  <h5 class="col-10 mb-0 text-left">
    Portal clásico
  </h5>
  <div class="col-md-auto col-2">
    <i (click)="close()" class="fas fa-times icon-close"></i>
  </div>
</div>
<mat-dialog-content>
  <div class="iframe-contenedor">
    @if (cargando) {
      <div class="loader-overlay">
        <p>Cargando contenido...</p>
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    }

    <iframe class="iframe-contenido" [src]="safeUrl" frameborder="0" allowfullscreen
      sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin"
      (load)="onIframeLoad()" (error)="onIframeError($event)">
    </iframe>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" [mat-dialog-close]="true">Cerrar</button>
</mat-dialog-actions>